import React from 'react'
import PlayArrowRoundedIcon from "@material-ui/icons/PlayArrowRounded";

function VideoItem({thumbnail, url, title, onPlay}) {
    return (
        <div className="gallery-video">
            <div className="thumbnail">
                <img src={thumbnail} alt={title} />
                <div className="play-btn">
                    <div className="btn-inner" onClick={onPlay}>
                        <PlayArrowRoundedIcon />
                    </div>
                </div>
            </div>
            <p className="video-title">{title}</p>
        </div>
    )
}

export default VideoItem
